import env from '@/env';
import { useLogout } from '@/hooks/useLogout';
import { useTranslation } from 'react-i18next';

// TODO (EPT-8329: hardcoded id - update this when we have access to mappings)
const DEFAULT_COMPETITION_ID = 1002;

export const useAccountNavigationItems = () => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation(['navigation']);
  const logout = useLogout();

  return [
    {
      id: 'default-team',
      label: t('crossPlatform.secondary.defaultTeam'),
      route: `https://${env.VITE_IQ_DOMAIN}/personalisation/my-default-team`,
    },
    {
      id: 'favorites',
      label: t('crossPlatform.secondary.favorites'),
      route: `https://${env.VITE_IQ_DOMAIN}/personalisation/my-favourites`,
    },
    {
      id: 'radar-templates',
      label: t('crossPlatform.secondary.radarTemplates'),
      route: `https://${env.VITE_IQ_DOMAIN}/personalisation/my-radar-templates`,
    },
    {
      id: 'distribution',
      label: t('crossPlatform.secondary.distribution'),
      route: `https://${env.VITE_IQ_DOMAIN}/personalisation/my-preferences`,
    },
    {
      id: 'default-gender',
      label: t('crossPlatform.secondary.defaultGender'),
      route: `/${locale}/settings/default-gender`,
    },
    {
      id: 'collection-status',
      label: t('crossPlatform.secondary.collectionStatus'),
      route: `https://${env.VITE_IQ_DOMAIN}/status/match-status/${DEFAULT_COMPETITION_ID}`,
    },
    {
      id: 'logout',
      label: t('crossPlatform.secondary.logout'),
      onClick: logout,
    },
  ];
};
